"use strict";

import { lcvManualPrizeWinsConstants } from "../_constants/lcvManualPrizeWins.constants";

export const INITIAL_LCV_MANUAL_PRIZE_WINS_STATE = {
     wins : { wins: [], totalCount: 0 },
     actionResult : null,
};

export function lcvManualPrizeWins(state = INITIAL_LCV_MANUAL_PRIZE_WINS_STATE, action) {
    switch (action.type) {
     // The BFF unwraps the gateway envelope, so the payload is already the bare result.
     case lcvManualPrizeWinsConstants.LCV_MANUAL_PRIZE_WINS_GET_COMPLETE:
          return {
               ...state,
               wins: action.payload || { wins: [], totalCount: 0 },
          };
     case lcvManualPrizeWinsConstants.LCV_MANUAL_PRIZE_WINS_SET_FULFILMENT_COMPLETE:
          return {
               ...state,
               actionResult: action.payload || null,
          };
     case lcvManualPrizeWinsConstants.LCV_MANUAL_PRIZE_WINS_CLEAR_ACTION_RESULT:
          return {
               ...state,
               actionResult: null,
          };
     default:
          return state;
    }
}
